module.exports = __webpack_public_path__ + "assets/learn-3.183ffce1.svg";